import { render } from "./PDO2.vue?vue&type=template&id=499118b8"
import script from "./PDO2.vue?vue&type=script&lang=js"
export * from "./PDO2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__